import axios from 'axios'
import queryString from 'query-string'
import { PaginationResponse } from 'src/models/pagination.models'
import { UserListResponse } from 'src/models/user.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import { GetUsersSearchRequest } from 'src/requests/getUsers.request'

export interface GetUsersResponse {
  users: UserListResponse[]
  pagination: PaginationResponse
}

// These network functions return response.data and let the raw axios error
// propagate (deliberately NOT routed through getResponseData/normalizeQueryError).
// useQueryOwnUser's PHONE_NOT_VERIFIED carve-out and the byte-identical GET_ME
// characterization tests (authFlows.characterization.test.tsx,
// __tests__/users.queries.test.tsx) read the backend error off the raw
// AxiosError's `response.data.error`. Normalizing would reshape that — and drop
// it entirely for the tests' non-isAxiosError mocks — breaking the carve-out.
// No consumer reads these queries' `.error`, so preserving the legacy raw shape
// is behaviour-identical to the retired useExtendQuery (which used raw axios.get).
export const getOwnUser = async (): Promise<UserListResponse> => {
  const response = await axios.get<UserListResponse>(
    'users/me',
    getRequestConfig(RequestConfig.Default),
  )
  return response.data
}

export const getUser = async (userId: string): Promise<UserListResponse> => {
  const response = await axios.get<UserListResponse>(
    `users/${userId}`,
    getRequestConfig(RequestConfig.Default),
  )
  return response.data
}

export const getUsersSearch = async (
  filters: GetUsersSearchRequest,
  page: number,
): Promise<GetUsersResponse> => {
  const response = await axios.get<GetUsersResponse>(
    `users/search?${queryString.stringify({ ...filters, page })}`,
    getRequestConfig(RequestConfig.Default),
  )
  return response.data
}
